import { render, staticRenderFns } from "./congratulation-dialog.vue?vue&type=template&id=06765462&scoped=true&"
import script from "./congratulation-dialog.vue?vue&type=script&lang=js&"
export * from "./congratulation-dialog.vue?vue&type=script&lang=js&"
import style0 from "./congratulation-dialog.vue?vue&type=style&index=0&id=06765462&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06765462",
  null
  
)

export default component.exports